// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarimplIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarimplIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarimplIconOutlined = function DrrpDarimplIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarimplIconOutlinedSvg
  }));
};

DrrpDarimplIconOutlined.displayName = 'DrrpDarimplIconOutlined';
export default React.forwardRef(DrrpDarimplIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarimplIconOutlined.js
// module id = 2526
// module chunks = 0